// ui/floating/FloatingToggleButton.tsx
import styled from "styled-components";


export const FloatingToggleButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;

  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  font-size: 24px;
  cursor: pointer;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);

  &:hover {
    opacity: 0.9;
  }
`;
